export default function checkRank(user, authorization = { allowedRanks: [], isFranchised: false }) {
  if (!user) {
    return false;
  }

  return 'isFranchised' in authorization
    ? authorization.isFranchised === user.isFranchised && authorization.allowedRanks.includes(user.type)
    : authorization.allowedRanks.includes(user.type);
}
